import { prop, max } from './index';
export default (families) => {
    return {
        width: max(families.map(prop('right'))),
        height: max(families.map(family => family.top + family.height)),
    };
};
//# sourceMappingURL=getCanvasSize.js.map